import React from 'react';
import flow from 'lodash/flow';
import Button from '@atlaskit/button/standard-button';
import { withFireUiAnalytics } from '@atlassian/jira-analytics-web-react/src';
import { ff } from '@atlassian/jira-feature-flagging';
import { injectIntl, type IntlShape } from '@atlassian/jira-intl';
import { Link } from '@atlassian/jira-router';
import messages from './messages';

export type CreateButtonProps = {
	onClick?: () => void;
};

type Props = CreateButtonProps & {
	intl: IntlShape;
};

export const CreateButton = ({ onClick, intl: { formatMessage } }: Props) => (
	<Button
		href={`/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`}
		onClick={onClick}
		appearance="primary"
		// @ts-expect-error - TS2322 - Type '{ children: string; href: string; onClick: (() => void) | undefined; appearance: "primary"; externalId: string; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
		externalId="directory.filters-v2.create-button"
		component={ff('nin.global-scope_aqec8') ? Link : undefined}
	>
		{formatMessage(messages.createFilter)}
	</Button>
);

export default flow(withFireUiAnalytics({ onClick: 'createFilter' }), injectIntl)(CreateButton);
